import React, { useState, useCallback } from 'react';
import { HashRouter, Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import { ThemeProvider } from './contexts/ThemeContext';
import { ReadingHistoryProvider } from './contexts/ReadingHistoryContext';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import HomePage from './components/HomePage/HomePage';
import CatalogPage from './components/CatalogPage/CatalogPage';
import PoetList from './components/PoetList/PoetList';
import PoemList from './components/PoemList/PoemList';
import PoemReader from './components/PoemReader/PoemReader';
import BiographyReader from './components/BiographyReader/BiographyReader';
import SearchResults from './components/SearchResults/SearchResults';
import './styles/main.scss';

const AppContent: React.FC = () => {
  const [isZenMode, setIsZenMode] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  // Check if we're in poem view mode
  const isPoemView = location.pathname.startsWith('/poem/');

  const handleSearchClick = useCallback(() => {
    navigate('/search');
  }, [navigate]);

  const handleZenModeChange = useCallback((zen: boolean) => {
    setIsZenMode(zen);
  }, []);

  return (
    <div className="app">
      <Header isHidden={isZenMode} onSearchClick={handleSearchClick} />

      <main className="app-container">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/catalog" element={<CatalogPage />} />
          <Route path="/catalog/:catalogId" element={<PoetList />} />
          <Route path="/poet/:poetId" element={<PoemList />} />
          <Route path="/bio/:poetId" element={<BiographyReader onZenModeChange={handleZenModeChange} />} />
          <Route path="/poem/:poemId" element={<PoemReader onZenModeChange={handleZenModeChange} />} />
          <Route path="/search" element={<SearchResults />} />
        </Routes>
      </main>

      <Footer isHidden={isZenMode} showFontSize={isPoemView} />
    </div>
  );
};

function App() {
  return (
    <ThemeProvider>
      <ReadingHistoryProvider>
        <HashRouter>
          <AppContent />
        </HashRouter>
      </ReadingHistoryProvider>
    </ThemeProvider>
  );
}

export default App;
